import store from "@/store";

export default async (to, from, next) => {
  await store.dispatch("setSignup");
  await store.dispatch("setCourseLookup", { formList: true });

  next();
};
